import React from "react"

import { BackgroundImage } from "components/shared/background-img"
import { Box } from "components/shared/box"

import joinBgImage from "/public/images/pages/auth/join-bg.webp"

export default function JoinBlock() {
  return (
    <BackgroundImage imageSrc={joinBgImage.src} className="flex flex-1 bg-center">
      <Box className="flex-1 p-10 bg-gradient-to-b from-[#3F089280_55%] to-[#3F0892]">
        <Box className="mt-auto font-bold text-[2.5rem] leading-none uppercase">
          join the largest bot economic crypto game
        </Box>
        <Box className="mt-4 font-medium text-[0.875rem] leading-normal">
          Assemble Bots and Spaceships into squads and dominate PvP arenas to earn BITS and OIL tokens!
        </Box>
      </Box>
    </BackgroundImage>
  )
}
